module.exports = __webpack_public_path__ + "img/H5.cb118aea.png";